/**
 * Abre o vídeo "Como falar com o Ataric" (GUIDE) em nova aba.
 * URLs por dispositivo: iOS Shorts, Android Shorts, desktop watch.
 */
export function openGuideVideo(): void {
  const ua = navigator.userAgent.toLowerCase();
  let url: string;
  if (/iphone|ipad|ipod/.test(ua)) {
    url = 'https://youtube.com/shorts/FiwKVonffzU?si=Z37cSWdG2V1siwKx';
  } else if (/android/.test(ua)) {
    url = 'https://youtube.com/shorts/g0TMwppZqZY?si=lCA8b878Hi0CnIQa';
  } else {
    url = 'https://www.youtube.com/watch?v=dkkwv-S52Xs';
  }
  window.open(url, '_blank');
}
